import styled from '@emotion/styled'

import { typo } from '~/@common/styles'
import { mediaQuery } from '~/@common/styles/mediaQuery'
import { Card } from '~/@common/ui/(Card)'
import Table from '~/@common/ui/Table/Table'

export const S = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
  `,

  ReportTable: styled(Table)`
    flex: 1;
    min-height: 0;

    thead tr {
      padding: 16px 24px;
    }

    tbody tr {
      min-height: 120px;
      padding: 14px 24px;
    }

    .period-cell {
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      gap: 4px;
      padding: 0 20px;
      overflow: hidden;
      min-width: 0;
    }

    .period-row {
      display: flex;
      gap: 12px;
      align-items: center;
      width: 100%;
      min-width: 0;
    }

    .period-label {
      ${typo.body02}
      color: var(--Colors-Gray-900);
      white-space: nowrap;
      flex-shrink: 0;
    }

    .period-divider {
      width: 1px;
      height: 12px;
      background-color: var(--Colors-Gray-300);
      flex-shrink: 0;
    }

    .period-text {
      ${typo.body02}
      color: var(--Colors-Gray-900);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }

    .chapter-list {
      display: flex;
      flex-direction: column;
      gap: 4px;
      min-width: 0;
      overflow: hidden;
    }

    .chapter-item {
      display: flex;
      align-items: center;
      gap: 6px;
      min-width: 0;
    }

    .chapter-text {
      ${typo.body02}
      color: var(--Colors-Gray-900);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }
  `,

  HeaderDivider: styled.div`
    width: 1px;
    background-color: var(--Colors-Gray-300);
    align-self: stretch;
  `,

  RightSection: styled.div`
    display: flex;
    gap: 18px;
    align-items: center;
    flex-shrink: 0;
  `,

  RowDivider: styled.div`
    width: 1px;
    height: 62px;
    background-color: var(--Colors-Gray-300);
    flex-shrink: 0;
  `,

  RankCell: styled.div`
    width: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    gap: 15px;

    ${mediaQuery.underTablet} {
      width: 60px;
    }

    .rank-number {
      ${typo.heading02};
      font-weight: 700;
      color: var(--Colors-Gray-800);
    }

    .rank-label {
      ${typo.caption01}
      color: var(--Colors-Gray-700);
    }
  `,

  GraphCell: styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    min-width: 308px;
  `,

  DonutItem: styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100px;
    height: 88px;
    .donut-value {
      position: absolute;
      top: 22px;
      left: 50%;
      transform: translateX(-50%);
      ${typo.caption01}
      color: var(--Colors-Gray-800);
      .donut-value-number {
        ${typo.heading05}
        font-weight: 700;
      }
    }
    .donut-label {
      ${typo.caption01}
      color: var(--Colors-Gray-700);
    }
    ${mediaQuery.underTablet} {
      width: 61px;
    }
  `,

  CardList: styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: auto;
    gap: 20px;
    padding-bottom: 20px;
  `,

  Card: styled(Card)`
    flex-shrink: 0;
    padding: 14px 20px;
    cursor: pointer;

    &:active {
      background-color: var(--Colors-Gray-100);
    }
  `,

  CardTitle: styled.div`
    ${typo.body02}
    font-weight: 700;
    color: var(--Colors-Gray-700);
    margin-bottom: 14px;
  `,

  CardInfoRow: styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 4px;

    .label {
      ${typo.body02}
      font-weight: 700;
      color: var(--Colors-Gray-900);
      white-space: nowrap;
    }

    .info-divider {
      width: 1px;
      height: 12px;
      background-color: var(--Colors-Gray-300);
      flex-shrink: 0;
    }

    .value {
      ${typo.caption01}
      color: var(--Colors-Gray-900);
    }

    .chapter-list {
      display: flex;
      flex-direction: column;
      gap: 4px;
      min-width: 0;
      overflow: hidden;
    }

    .chapter-item {
      display: flex;
      align-items: center;
      gap: 6px;
      min-width: 0;
    }

    .chapter-text {
      ${typo.body02}
      color: var(--Colors-Gray-900);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;
    }
  `,

  CardDivider: styled.div`
    height: 1px;
    background-color: var(--Colors-Gray-300);
    margin: 14px 0 0;
  `,

  CardBottom: styled.div`
    display: flex;
    align-items: center;
    gap: 18px;
    padding-top: 14px;

    ${mediaQuery.underTablet} {
      gap: 12px;
    }
  `,

  DonutGroup: styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    flex: 1;
    justify-content: space-around;
  `,

  Empty: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 300px;

    ${typo.body02}
    color: var(--Colors-Gray-500);
  `,

  Sentinel: styled.div`
    height: 1px;
  `,

  Loading: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;

    ${typo.caption01}
    color: var(--Colors-Gray-500);
  `,
}
